'use client';

import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ComparisonState = {
  products: Product[];
  addProduct: (product: Product) => void;
  removeProduct: (id: number) => void;
  toggleProduct: (product: Product) => void;
  isInComparison: (id: number) => boolean;
  clearAll: () => void;
};

export const useComparisonStore = create<ComparisonState>()(
  persist(
    (set, get) => ({
      products: [],

      addProduct: product =>
        set(state => {
          if (state.products.some(p => p.id === product.id)) return state;
          return { products: [...state.products, product] };
        }),

      removeProduct: id =>
        set(state => ({ products: state.products.filter(p => p.id !== id) })),

      toggleProduct: product => {
        const { products } = get();
        if (products.some(p => p.id === product.id)) {
          set({ products: products.filter(p => p.id !== product.id) });
        } else {
          set({ products: [...products, product] });
        }
      },

      isInComparison: id => get().products.some(p => p.id === id),

      clearAll: () => set({ products: [] }),
    }),
    {
      name: 'product-comparison',
    },
  ),
);
